import { useState, useEffect, ReactNode } from 'react'
import { initializeCookieSync } from '../../auth.utils'

interface CookieSyncProps {
    children: ReactNode
    loadingComponent?: ReactNode
}

export function CookieSync({
    children,
    loadingComponent = <span>Authenticating...</span>,
}: CookieSyncProps) {
    const [cookieSyncReady, setCookieSyncReady] = useState(false)

    useEffect(() => {
        const cookieSync = initializeCookieSync({
            onReady: () => {
                setCookieSyncReady(true)
            },
        })

        return () => {
            cookieSync.cleanup()
        }
    }, [])

    return cookieSyncReady ? children : loadingComponent
}
